const carsTable = [
    [
        {id: 0, row: 4, col: 1, direction: 'vertical', length: 2, color: 'red', exit: 1, exit_edge: "exit-top", step: 12},
        {id: 1, row: 1, col: 1, direction: 'horizontal', length: 3, color: 'darkslategray'},
        {id: 2, row: 2, col: 1, direction: 'horizontal', length: 3, color: 'dimgray'},
        {id: 3, row: 1, col: 4, direction: 'horizontal', length: 2, color: 'green'},
        {id: 4, row: 1, col: 6, direction: 'vertical', length: 2, color: 'yellow'},
        {id: 5, row: 2, col: 4, direction: 'horizontal', length: 2, color: 'blue'},
        {id: 6, row: 3, col: 1, direction: 'horizontal', length: 2, color: 'purple'}
    ],
    [
        {id: 0, row: 2, col: 1, direction: 'vertical', length: 2, color: 'red', exit: 1, exit_edge: 'exit-top', step: 18},
        {id: 1, row: 1, col: 1, direction: 'horizontal', length: 2, color: 'blue'},
        {id: 2, row: 1, col: 3, direction: 'horizontal', length: 2, color: 'green', exit: 1},
        {id: 3, row: 1, col: 5, direction: 'vertical', length: 3, color: 'darkslategray', exit: 1},
        {id: 4, row: 3, col: 2, direction: 'horizontal', length: 2, color: 'purple', exit: 1},
        {id: 5, row: 4, col: 3, direction: 'vertical', length: 3, color: 'dimgray', exit: 1},
        {id: 6, row: 4, col: 5, direction: 'vertical', length: 2, color: 'yellow', exit: 1},
        {id: 7, row: 6, col: 4, direction: 'horizontal', length: 2, color: 'lightblue', exit: 1},
    ],
    [
        {id: 0, row: 4, col: 1, direction: 'vertical', length: 2, color: 'red', exit: 1, exit_edge: 'exit-top', step: 19}, //table 3
        {id: 1, row: 1, col: 1, direction: 'horizontal', length: 3, color: 'dimgray', exit: 1},
        {id: 2, row: 1, col: 4, direction: 'horizontal', length: 2, color: 'green', exit: 1},
        {id: 3, row: 1, col: 6, direction: 'vertical', length: 2, color: 'yellow', exit: 1},
        {id: 4, row: 2, col: 1, direction: 'horizontal', length: 3, color: 'darkslategray', exit: 1},
        {id: 5, row: 2, col: 4, direction: 'horizontal', length: 2, color: 'blue', exit: 1},
        {id: 6, row: 3, col: 1, direction: 'horizontal', length: 2, color: 'purple', exit: 1},
        {id: 7, row: 3, col: 4, direction: 'vertical', length: 2, color: 'purple', exit: 1},
        {id: 8, row: 3, col: 5, direction: 'horizontal', length: 2, color: 'lightblue', exit: 1},
        {id: 9, row: 4, col: 6, direction: 'vertical', length: 2, color: 'dimgray', exit: 1},
        {id: 10, row: 5, col: 4, direction: 'horizontal', length: 2, color: 'green', exit: 1},
        {id: 11, row: 6, col: 3, direction: 'horizontal', length: 2, color: 'yellow', exit: 1},
        {id: 12, row: 6, col: 5, direction: 'horizontal', length: 2, color: 'dimgray', exit: 1},
    ],
    [
        {id: 0, row: 5, col: 1, direction: 'vertical', length: 2, color: 'red', exit: 1, exit_edge: 'exit-top', step: 20},
        {id: 1, row: 1, col: 1, direction: 'horizontal', length: 3, color: 'dimgray', exit: 1, step: 20},
        {id: 2, row: 1, col: 4, direction: 'vertical', length: 3, color: 'violet', exit: 1, step: 20},
        {id: 3, row: 2, col: 1, direction: 'horizontal', length: 2, color: 'lightblue', exit: 1, step: 20},
        {id: 4, row: 3, col: 1, direction: 'horizontal', length: 2, color: 'purple', exit: 1, step: 20},
        {id: 5, row: 4, col: 1, direction: 'horizontal', length: 2, color: 'blue', exit: 1, step: 20},
        {id: 6, row: 4, col: 3, direction: 'vertical', length: 2, color: 'dimgray', exit: 1, step: 20},
        {id: 7, row: 4, col: 4, direction: 'vertical', length: 2, color: 'purple', exit: 1, step: 20},
        {id: 8, row: 6, col: 2, direction: 'horizontal', length: 3, color: 'darkslategray', exit: 1, step: 20},
    ],
    [
        {id: 0, row: 5, col: 1, direction: 'vertical', length: 2, color: 'red', exit: 1, exit_edge: 'exit-top', step: 24},
        {id: 1, row: 1, col: 1, direction: 'horizontal', length: 3, color: 'dimgray', exit: 1, step: 24},
        {id: 2, row: 1, col: 4, direction: 'vertical', length: 3, color: 'violet', exit: 1, step: 24},
        {id: 3, row: 2, col: 1, direction: 'horizontal', length: 2, color: 'lightblue', exit: 1, step: 24},
        {id: 4, row: 2, col: 5, direction: 'vertical', length: 2, color: 'yellow', exit: 1, step: 24},
        {id: 5, row: 2, col: 6, direction: 'vertical', length: 2, color: 'green', exit: 1, step: 24},
        {id: 6, row: 3, col: 1, direction: 'horizontal', length: 2, color: 'purple', exit: 1, step: 24},
        {id: 7, row: 4, col: 1, direction: 'horizontal', length: 2, color: 'blue', exit: 1, step: 24},
        {id: 8, row: 4, col: 3, direction: 'vertical', length: 2, color: 'dimgray', exit: 1, step: 24},
        {id: 9, row: 4, col: 4, direction: 'vertical', length: 2, color: 'purple', exit: 1, step: 24},
        {id: 10, row: 4, col: 5, direction: 'vertical', length: 3, color: 'darkgreen', exit: 1, step: 24},
        {id: 11, row: 4, col: 6, direction: 'vertical', length: 3, color: 'darkcyan', exit: 1, step: 24},
        {id: 12, row: 6, col: 2, direction: 'horizontal', length: 3, color: 'darkslategray', exit: 1, step: 24},
    ],
    [
        {id: 0, row: 2, col: 5, direction: 'vertical', length: 2, color: 'red', exit: 5, exit_edge: 'exit-top', step: 16}, //table 6
        {id: 1, row: 1, col: 3, direction: 'vertical', length: 2, color: 'purple', exit: 1},
        {id: 2, row: 1, col: 4, direction: 'horizontal', length: 3, color: 'dimgray', exit: 1},
        {id: 3, row: 3, col: 2, direction: 'horizontal', length: 3, color: 'darkslategray', exit: 1},
    ],
];

export default carsTable;